import { render, staticRenderFns } from "./ShopView.vue?vue&type=template&id=fe826aee&scoped=true"
import script from "./ShopView.vue?vue&type=script&lang=ts"
export * from "./ShopView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe826aee",
  null
  
)

export default component.exports